<div *ngIf="taxNews?.length>0" class="flex flex-col">
    <div class="title-section flex flex-row justify-between items-center">
        <h2> Today's tax news</h2>
        <a (click)="onClickedViewAll()" class="pointer">View All<i class="far fa-long-arrow-right"></i></a>
    </div>
    <div class="content-container flex flex-row justify-start items-start">
        <a  *ngFor="let tn of taxNews; let i = index" (click)="onClickedNewsItem(i)" class="pointer ">
            <div class="each-seaction">
                <img [src]="tn.imageUrl">
                <p class="country-name">{{tn.country}}</p>
                <div class="title">{{tn.title}}</div>
                <div class="description" [innerHtml]="tn.description"></div>
            </div>
        </a>
    </div>
</div>
